import {
    buildQueryFromUrl,
    pushFiltersToUrl
} from "@/common/lib/url-query-filters";

const SORT_SUB_KEYS = ["orderBy", "orderType"];

export default {
    created() {
        const schema = this.$data.$urlFilterSchema;
        if (schema && schema.length) {
            const urlQuery = buildQueryFromUrl(this.$route.query, schema);
            this.query = { ...this.query, ...urlQuery };
        }

        const paginationKey = this.$data.$urlPaginationKey;
        if (paginationKey) {
            const urlPagination = buildQueryFromUrl(this.$route.query, [
                { key: paginationKey, type: "number" }
            ]);
            if (urlPagination[paginationKey] !== undefined) {
                this.currentPage = urlPagination[paginationKey];
            }
        }

        const sortKey = this.$data.$urlSortKey;
        if (sortKey) {
            const urlSort = buildQueryFromUrl(this.$route.query, [
                { key: sortKey, type: "range", subKeys: SORT_SUB_KEYS }
            ]);
            if (urlSort[sortKey] !== undefined) {
                this.sortConfig = urlSort[sortKey];
            }
        }
    },
    watch: {
        query: {
            handler(query) {
                const schema = this.$data.$urlFilterSchema;
                if (!schema || !schema.length) return;
                pushFiltersToUrl(query, schema);
            },
            deep: true
        },
        currentPage(page) {
            const paginationKey = this.$data.$urlPaginationKey;
            if (!paginationKey) return;
            pushFiltersToUrl({ [paginationKey]: page > 1 ? page : undefined }, [
                { key: paginationKey, type: "number" }
            ]);
        },
        sortConfig: {
            handler(sortConfig) {
                const sortKey = this.$data.$urlSortKey;
                if (!sortKey) return;
                pushFiltersToUrl({ [sortKey]: sortConfig }, [
                    { key: sortKey, type: "range", subKeys: SORT_SUB_KEYS }
                ]);
            },
            deep: true
        }
    }
};
